import styled from "@emotion/styled";
import { Box, TextField } from "@mui/material";

export const ProfileForm = styled(Box)({
  width: "100%",
});

export const FormWrapper = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
});

export const FormInput = styled(TextField)({
  width: "48%",
  marginBottom: 32,
});

export const ButtonContainer = styled(Box)({
  display: "flex",
  gap: 12,
  justifyContent: "right",
  marginTop: 64,
});
